export default class MassiaValidateController {
	/* @ngInject */
	constructor($scope, $state, $stateParams, notification, $location, $translate, SharedDataService, $http) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$http = $http;
		this.ngModels = {};
		///// variables
		this.icon = '';
		this.isProcessing = false;
	}

	async $onInit() {
		if (this.config) {
			if (this.config.icon == 'ADD') {
				this.icon = 'glyphicon glyphicon-plus';
			}
		}
	}

	validateForm() {
		this.isProcessing = true;
		this.executeUrl().finally(() => {
			this.isProcessing = false;
		});
	}

	async executeUrl() {
		let url = `${__configuration.apiUrl}` + this.config.route;
		console.log('-------------------------------------------------------------------------------------------');
		console.log('METHODE POST :');
		console.log(url);
		console.log(this.SharedDataService.getAllData());
		console.log('-------------------------------------------------------------------------------------------');
		const data = this.SharedDataService.getAllData();

		try {
			var result = await this.$http.post(url, data);

			console.log('--------------------------------------------');
			console.log('---               RESULT                 ---');
			console.log('--------------------------------------------');
			console.log(result);
			console.log('result2');
			console.log(JSON.parse(JSON.stringify(result)));
			console.log('-------------------------------------------------------------------------------------------');

			await this.SharedDataService.setAllData(result.data.data);

			// Gestion des retour pour l'affichage d'un POPUP (exemple dans CessionsController.cs)
			// public async Task<IHttpActionResult> Post([FromBody] CessionAutoriseDto data)
			// return Ok(new { success = false, message = "ERROR" });
			// return Ok(new { success = command.Success, message = command.Message });

			if (result.data.success == false) {
				this.notification.error(result.data.message);
			} else {
				this.notification.success(result.data.message);
				if (this.config.callbackSuccess) this.config.callbackSuccess();
			}
		} catch (error) {
			console.error('Erreur lors de la requête POST :', error);
			alert(error.data.message);
		}
	}

	$onDestroy() {
		// Nettoyage si nécessaire
	}
}
